import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

export type FeatureFlagsResponse = {
  id: number;
  featureName: string;
  isEnabled: boolean;
};

type GetFeatureFlagRequest = {
  token: string;
};

const getFeatureFlagsList = async ({
  token,
}: GetFeatureFlagRequest): Promise<FeatureFlagsResponse[]> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/feature/get-feature-flag`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);
    (e as Error).message = message;
    throw e;
  }
};

export default getFeatureFlagsList;
